import {useEffect} from 'react';
import {useEvent} from './use-event';

type UseClickEscapeProps = {
  enabled?: boolean;
  onClick?: () => void;
};

export function useClickEscape({enabled = true, onClick}: UseClickEscapeProps) {
  const handler = useEvent(onClick);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && enabled) {
        handler();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handler, enabled]);
}
